import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateRangeOrderValidator(
  fromKey: string,
  untilKey: string
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const fromCtrl = group.get(fromKey);
    const untilCtrl = group.get(untilKey);

    if (!fromCtrl || !untilCtrl) return null;

    const fromValue = fromCtrl.value;
    const untilValue = untilCtrl.value;

    if (!fromValue || !untilValue) return null;

    const [fd, fm, fy] = fromValue.split('/').map(Number);
    const [ud, um, uy] = untilValue.split('/').map(Number);

    const fromDate = new Date(fy, fm - 1, fd);
    const untilDate = new Date(uy, um - 1, ud);

    fromCtrl.setErrors(null);
    untilCtrl.setErrors(null);

    if (fromDate > untilDate) {
      fromCtrl.setErrors({ ...(fromCtrl.errors || {}), dateRangeInvalid: true });
      untilCtrl.setErrors({ ...(untilCtrl.errors || {}), dateRangeInvalid: true });
      return { dateRangeInvalid: true };
    }

    return null;
  };
}